import { Slide } from "@mui/material";
import React, { forwardRef } from "react";

const FullScreenDialogTransition = forwardRef((props, ref) => (
    <Slide ref={ref} direction="up" {...props} />
));

export { FullScreenDialogTransition };
